import { lazy } from 'react';
export var TestEditPageAsync = lazy(function () { return import('./TestEditPage'); });
